import axios from 'axios';

import { API_BASE_URL } from '../../utils/constants';

export const handleFetchConversations = async (
  startDate,
  endDate,
  channelId
) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/admin/conversations/statistics?date=false',
    params: {
      start: startDate,
      end: endDate,
      channelId,
    },
    // withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleFetchAgentStartedConversations = async (
  startDate,
  endDate,
  channelId
) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/admin/conversations/statistics/agentStarted',
    params: {
      start: startDate,
      end: endDate,
      channelId,
    },
    // withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleFetchMessages = async (startDate, endDate) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/admin/chats/statistics',
    params: {
      start: startDate,
      end: endDate,
    },
    // withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });

  return response.data;
};

export const handleFetchShortTermChats = async (startDate, endDate, id) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/admin/chats/statistics',
    params: {
      start: startDate,
      end: endDate,
      channelId: id,
    },
    // withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });

  return response.data;
};

export const handleFetchLongTermChats = async (startDate, endDate, id) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/admin/chats/longStatistics',
    params: {
      start: startDate,
      end: endDate,
      channelId: id,
    },
    // withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });

  return response.data;
};

export const handleSubmitRequestForChats = async (startDate, endDate, id) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/admin/chats/computeStatistics',
    params: {
      start: startDate,
      end: endDate,
      channelId: id,
    },
    // withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });

  return response.data;
};

export const handleExportMessages = async (startDate, endDate, types) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/admin/chats/statistics/export',
    params: {
      start: startDate,
      end: endDate,
      types,
    },
    // withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });

  return response.data;
};

export const handleExportCountLimit = async (channelId) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/admin/chats/statistics/checkExport',
    params: {
      channelId,
    },
    // withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });

  return response.data;
};

export const handleRequestChatsExport = async (
  startDate,
  endDate,
  types,
  channelId
) => {
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/admin/chats/statistics/export',
    params: {
      start: startDate,
      end: endDate,
      types,
      channelId,
    },
    // withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });

  return response.data;
};
